import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, CreditCard, Clock, CheckCircle2 } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';

export const TrialExpiredScreen = ({ onLogout }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <div className="max-w-lg w-full">
        <Card className="border-0 shadow-2xl">
          <CardHeader className="text-center pb-2">
            <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
              <Lock className="w-8 h-8 text-red-600" />
            </div>
            <CardTitle className="text-2xl text-slate-900" style={{ fontFamily: 'Manrope' }}>
              Período de Teste Expirado
            </CardTitle>
            <CardDescription className="text-base mt-2">
              Seu período de teste de 7 dias chegou ao fim. Para continuar usando o sistema, escolha um plano.
            </CardDescription>
          </CardHeader>
          
          <CardContent className="space-y-6">
            {/* Benefícios */}
            <div className="bg-slate-50 rounded-lg p-4 space-y-3">
              <h3 className="font-medium text-slate-900 flex items-center gap-2">
                <CreditCard className="w-4 h-4 text-teal-600" />
                Ao assinar você terá:
              </h3>
              <ul className="space-y-2 text-sm text-slate-600">
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-green-500" />
                  Documentos e alvarás ilimitados
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-green-500" />
                  Verificações diárias ilimitadas
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-green-500" />
                  Itens calibráveis ilimitados
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-green-500" />
                  Alertas por email automáticos
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-green-500" />
                  Suporte por ticket prioritário
                </li>
                <li className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4 text-green-500" />
                  Relatórios avançados
                </li>
              </ul>
            </div>

            {/* Botões */}
            <div className="space-y-3">
              <Button 
                onClick={() => navigate('/assinatura')}
                className="w-full bg-teal-600 hover:bg-teal-700 h-12 text-base"
              >
                <CreditCard className="w-5 h-5 mr-2" />
                Escolher Plano e Assinar
              </Button>
              
              <Button 
                variant="outline"
                onClick={onLogout}
                className="w-full"
              >
                Sair da Conta
              </Button>
            </div>

            {/* Contato */}
            <p className="text-center text-xs text-slate-500">
              Dúvidas? Entre em contato pelo WhatsApp:{' '}
              <a 
                href="https://wa.me/5511999999999" 
                className="text-teal-600 hover:underline"
                target="_blank"
                rel="noopener noreferrer"
              >
                (11) 99999-9999
              </a>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TrialExpiredScreen;
